export default __webpack_public_path__ + "static/media/direct_selling_3.10c03365.svg";